<template>
  <a-layout class="nhf-app" ref="contentBox">
    <a-alert style="
        position: fixed;
        width: 500px;
        min-height: 100px;
        top: 10%;
        left: 50%;
        margin-left: -250px;
        z-index: 100000;
      " v-if="ebsIsFalse" :message="ebsMessage" :type="ebsType" show-icon>
      <div slot="description">
        <!-- This is an error message about copywriting.1111111111
        ebsList -->
        <div v-if="ebsType !== 'success'">
          <span v-for="(el, index) in ebsList" :key="el.id">{{ el.name }}【{{ el.code }}】{{
            index === ebsList.length - 1 ? "" : "、"
            }}</span>
          库存不存在；
        </div>
        <div style="text-align: left">
          <a @click="closeEbsAlert">{{
            ebsType === "success" ? "我知道了" : "返回修改"
            }}</a>
          <a-divider type="vertical" />
          <a v-if="ebsType === 'success'" @click="() => saveFormula({ key: 2 })">生成产品</a>
          <a v-else @click="copyMsg">复制信息</a>
        </div>
      </div>
    </a-alert>
    <a-spin :spinning="lineLoading || updateLoading" :tip="updateLoading ? null : '配方优化中，请稍后'">
      <a-layout-content class="nhf-editor">
        <a-row justify="space-between" type="flex" class="nhf-header">
          <h1 class="nhf-title" @click="goBack">
            <img class="nhf-logo" :src="logo" alt="返回上一页面" />
            <span class="newTextColor">{{ factoryName }}</span>
          </h1>
          <a-space>
            <a-tooltip>
              <template slot="title"> 全屏显示 </template>
              <a @click="full">
                <img v-if="!isFullScreen" :src="fullScreen" alt="全屏显示" />
                <img v-else :src="exitFullScreen" alt="退出全屏" />
              </a>
            </a-tooltip>
            <template v-if="RMPButton">
              <a-divider type="vertical" />
              <a-button size="small" type="default" @click="openRMPResult">研发成果应用</a-button>
            </template>
            <a-divider type="vertical" />
            <a-button type="primary" size="small" @click="changeLinear({ key: 1 })">配方优化</a-button>
            <a-button size="small" @click="changeLinear({ key: 2 })">取整优化</a-button>
            <a-button size="small" @click="openAddExtraRaw">额外添加原料</a-button>
            <a-divider type="vertical" />

            <a-button :disabled="detail.isProduct == 0" size="small" @click="togglePorductVisible">产品对比</a-button>

            <a-button :disabled="detail.formulaSolutionType != 1" size="small" @click="checkEBS">EBS校验</a-button>
            <a-dropdown>
              <a-button size="small" ghost type="primary">查看报表</a-button>
              <!-- ,'配方产品报表','生产产品报表' -->
              <a-menu slot="overlay" @click="viewReport">
                <a-menu-item :key="index + 1" v-for="(item, index) in [
                  '配方报表',
                  '生产报表',
                  '配方产品报表',
                  '生产产品报表',
                  '日粮配方报表',
                ]">{{ item }}</a-menu-item>
              </a-menu>
            </a-dropdown>
            <a-dropdown>
              <a-button size="small" :loading="saveLoading" style="width: 84px" type="primary">保存</a-button>
              <a-menu slot="overlay" @click="saveFormula">
                <a-menu-item v-for="(item, index) in [
                  '仅保存',
                  '更新版本',
                  '生成产品',
                  '保存为原料',
                ]" :key="index">{{ item }}</a-menu-item>
                <!-- <a-menu-item v-for="(item,index) in ['更新版本','生成产品']" :key="index">{{item}}</a-menu-item> -->
              </a-menu>
            </a-dropdown>
          </a-space>
        </a-row>
        <div class="nhf-container" ref="editorContainer" @contextmenu.prevent.stop="handleMenu($event)">
          <a-row type="flex" align="middle" class="nhf-header-main" justify="space-between">
            <a-space ref="formulaNameRef">
              <h3>{{ detail.formulaName }}</h3>
              <a-icon size="small" style="font-size: 15px" @click="toggleEditorVisible" type="form" />
            </a-space>
            <div ref="priceRef" :style="{ display: topPriceType ? 'flex' : 'block' }">
              <a-row type="flex" align="middle" justify="space-between" style="padding: 0">
                <div class="col">
                  混合日粮优化成本(元)：{{ formulaPrice }}
                  <h2>
                    {{
                    !formulaExtMix.mixPrice
                    ? "0.0"
                    : formulaExtMix.mixPrice.toFixed(titlePriceLen)
                    }}
                    <span v-if="mixComputedPrice != 0.0" :class="{
                      red: mixComputedPrice > 0,
                      green: mixComputedPrice < 0,
                    }">
                      <b>/</b>{{ mixComputedPrice }}
                      <a-icon style="font-size: 16px" :type="mixPriceType" />
                    </span>
                  </h2>
                  <div v-if="!!detail.referPriceSource && !topPriceType" style="opacity: 0">
                    补充料配方成本(元/吨)：{{ distributionPrice }}
                    <h2 class="referencePrice">
                      {{
                      !detail.referPrice
                      ? Number(0).toFixed(titlePriceLen)
                      : detail.referPrice.toFixed(titlePriceLen)
                      }}
                      <span v-if="Number(referPriceDiff)" :class="{
                        red: referPriceDiff > 0,
                        green: referPriceDiff < 0,
                      }">
                        <b>/</b>{{ referPriceDiff }}
                        <a-icon style="font-size: 16px" :type="referPriceDiffType" />
                      </span>
                    </h2>
                  </div>
                </div>
                <a-divider type="vertical" />
                <div class="col">
                  <div>
                    <div style="display: flex">
                      配销差(元/吨)：{{ formulaPrice }}
                      <a-tooltip style="margin-left: 15px">
                        <template slot="title"> 编辑配销差 </template>
                        <a-icon type="form" @click="openDistribution" size="small" style="
                            font-size: 12px;
                            cursor: pointer;
                            padding-top: 2px;
                            color: #1677ff;
                          " />
                      </a-tooltip>
                    </div>
                    <h2>
                      {{
                      !distributionPriceNum && distributionPriceNum !== 0
                      ? "-"
                      : distributionPriceNum.toFixed(titlePriceLen)
                      }}
                    </h2>
                  </div>
                  <div v-if="!!detail.referPriceSource && !topPriceType">
                    配销差(元/吨)：{{ distributionPrice }}
                    <h2 class="referencePrice">
                      {{
                      !referDistributionPriceNum &&
                      referDistributionPriceNum !== 0
                      ? "-"
                      : referDistributionPriceNum.toFixed(titlePriceLen)
                      }}
                    </h2>
                  </div>
                </div>

                <a-divider type="vertical" />
                <div class="col">
                  补充料优化成本(元/吨)：{{ formulaPrice }}
                  <h2>
                    {{
                    detail.price === null
                    ? "0.000"
                    : (detail.price || 0).toFixed(titlePriceLen)
                    }}
                    <span v-if="computedPrice != 0.0" :class="{
                      red: computedPrice > 0,
                      green: computedPrice < 0,
                    }">
                      <b>/</b>{{ computedPrice }}
                      <a-icon style="font-size: 16px" :type="priceType" />
                    </span>
                  </h2>
                  <div v-if="!!detail.referPriceSource && !topPriceType">
                    补充料配方成本(元/吨)：{{ distributionPrice }}
                    <h2 class="referencePrice">
                      {{
                      !detail.referPrice
                      ? Number(0).toFixed(titlePriceLen)
                      : detail.referPrice.toFixed(titlePriceLen)
                      }}
                      <span v-if="Number(referPriceDiff)" :class="{
                        red: referPriceDiff > 0,
                        green: referPriceDiff < 0,
                      }">
                        <b>/</b>{{ referPriceDiff }}
                        <a-icon style="font-size: 16px" :type="referPriceDiffType" />
                      </span>
                    </h2>
                  </div>
                </div>
                <a-divider type="vertical" />

                <div class="col">
                  产品成本(元/吨)：{{ formulaPrice }}
                  <h2>
                    <span v-if="productPrice">{{
                      !productPrice.price
                      ? "0.0"
                      : productPrice.price.toFixed(titlePriceLen)
                      }}</span>
                    <span v-if="
                      computedProductPrice != 0.0 && productPrice.version > 0
                    " :class="{
                      red: computedProductPrice > 0,
                      green: computedProductPrice < 0,
                    }">
                      <b>/</b>{{
                      Number(computedProductPrice).toFixed(titlePriceLen)
                      }}
                      <a-icon style="font-size: 16px" :type="productPriceType" />
                    </span>
                    <span style="
                        font-weight: normal;
                        color: rgba(0, 0, 0, 0.65);
                        font-size: 12px;
                        margin-left: 3px;
                      " v-if="hasProductVersion">({{ productPrice.createTime }}，V{{
                      productPrice.version
                      }})</span>
                  </h2>
                  <div v-if="!!detail.referPriceSource && !topPriceType">
                    产品成本(元/吨)：{{ distributionPrice }}
                    <h2 class="referencePrice">
                      {{
                      !productPrice.referPrice
                      ? Number(0).toFixed(titlePriceLen)
                      : productPrice.referPrice.toFixed(titlePriceLen)
                      }}
                      <span v-if="
                        referComputedPrice != 0.0 && productPrice.version > 0
                      " :class="{
                        red: referComputedPrice > 0,
                        green: referComputedPrice < 0,
                      }">
                        <b>/</b>{{ referComputedPrice }}
                        <a-icon style="font-size: 16px" :type="referComputedPriceType" />
                      </span>
                    </h2>
                  </div>
                </div>
              </a-row>
              <a-row type="flex" align="middle" justify="space-between" style="padding: 0"
                v-if="!!detail.referPriceSource && topPriceType">
                <div class="col" style="opacity: 0" v-if="!topPriceType">
                  混合日粮优化成本(元)
                </div>
                <a-divider type="vertical" style="opacity: 0" />
                <div class="col">
                  补充料配方成本(元/吨)：{{ distributionPrice }}
                  <h2 class="referencePrice">
                    {{
                    !detail.referPrice
                    ? Number(0).toFixed(titlePriceLen)
                    : detail.referPrice.toFixed(titlePriceLen)
                    }}
                    <span v-if="Number(referPriceDiff)" :class="{
                      red: referPriceDiff > 0,
                      green: referPriceDiff < 0,
                    }">
                      <b>/</b>{{ referPriceDiff }}
                      <a-icon style="font-size: 16px" :type="referPriceDiffType" />
                    </span>
                  </h2>
                </div>
                <a-divider type="vertical" />
                <div class="col">
                  <!-- 产品价格（元/吨） -->
                  配销差(元/吨)：{{ distributionPrice }}
                  <h2 class="referencePrice">
                    {{
                    !referDistributionPriceNum &&
                    referDistributionPriceNum !== 0
                    ? "-"
                    : referDistributionPriceNum.toFixed(titlePriceLen)
                    }}
                  </h2>
                </div>
                <a-divider type="vertical" />
                <div class="col">
                  产品成本(元/吨)：{{ distributionPrice }}
                  <h2 class="referencePrice">
                    {{
                    !productPrice.referPrice
                    ? Number(0).toFixed(titlePriceLen)
                    : productPrice.referPrice.toFixed(titlePriceLen)
                    }}
                    <span v-if="
                      referComputedPrice != 0.0 && productPrice.version > 0
                    " :class="{
                      red: referComputedPrice > 0,
                      green: referComputedPrice < 0,
                    }">
                      <b>/</b>{{ referComputedPrice }}
                      <a-icon style="font-size: 16px" :type="referComputedPriceType" />
                    </span>
                  </h2>
                </div>
                <a-icon v-if="!topPriceType" type="form" @click="openDistribution" size="small"
                  style="font-size: 15px; cursor: pointer; opacity: 0" />
              </a-row>
            </div>
          </a-row>
          <!-- layout 1 -->
          <div class="nhf-layout" ref="box" style="overflow: hidden" :style="{ height: 'calc(100% - 60px)' }">
            <!-- 左侧 -->
            <div class="tableleft" style="height: calc(100%); position: relative; width: 50%">
              <div style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 5px;
                  bottom: 10px;
                  z-index: 1000;
                  background: #fff;
                " v-if="nutVisible">
                <nutrition-raw-box ref="nutritionRawBox" />
              </div>
              <div class="leftBoxTopHeight" style="" ref="leftBoxTopHeight">
                <raw-editor style="height: 100%" @refresh="refreshUpdate" @getRes="getRes" @prcieChange="prcieChange"
                  ref="rawBlockTop" @add="toggleRawPanel" :weightNum="mixWeight" @ok="calculation"
                  @countPrice="countPrice"  @select="handleRawEditorSelectedRowKeysUpdate"></raw-editor>
              </div>
              <div class="resizeBottom" :span="1" title="上下拖动调整高度"></div>

              <div class="tableBottom" style="" ref="leftBoxBottomHeight">
                <raw-editor2 style="height: calc(100% - 20px)" @refresh="refreshUpdate" @getRes="getRes"
                  @countPrice="countPrice" @prcieChange="prcieChange" ref="rawBlockBottom" @add="toggleRawPanel"
                  :weightNum="blendWeight"  @select="handleRawEditor2SelectedRowKeysUpdate"></raw-editor2>
              </div>
            </div>

            <!-- 中线 -->
            <div class="resize" :style="{
              height: detail.referPriceSource
                ? 'calc(100vh - 170px)'
                : 'calc(100vh - 125px)',
            }" :span="1" title="左右拖动调整宽度"></div>

            <!-- 右侧 -->
            <div class="tableright" style="
                position: relative;
                height: calc(100% - 20px);
                width: 49.6%;
              ">
              <div style="
                  position: absolute;
                  top: 0;
                  left: 5px;
                  right: 0;
                  bottom: 0px;
                  z-index: 1000;
                  background: #fff;
                " v-if="calculaVisible">
                <calcula-box-modal ref="calculaBoxModal" @refresh="refreshList" @getRes="getRes" />
              </div>
              <nutrition-editor style="padding-left: 15px" @refresh="totalRefreshUpdate" ref="nutritionBlock"
                @res="getDetail" @changeTab="changeTab" @ok="calculation" :hasProductVersion="hasProductVersion">
                <a-button type="primary" :disabled="!nutRows.length" ghost @click="toggleHidden('nutRows')"
                  size="small">营养养分控制</a-button>
              </nutrition-editor>
            </div>
          </div>
        </div>
      </a-layout-content>
      <product-comparison :hidden="productVisible" @cancel="togglePorductVisible" :productPrice="productPrice" />
      <compound-create-modal ref="editRow" :hidden="editorVisible" @ok="update" @cancel="toggleEditorVisible" />
      <analyse-modal :rawitem="rawRows" :hidden="analyseVisible" @close="toggleAnalyse" />
      <check-EBS :visible="ebsPushVisible" @close="closeCheckEBS" @checkEbsRes="checkEbsRes" />
      <raw-save-modal @ok="refreshPage" />

      <vue-simple-context-menu :elementId="'layoutMenu'" :options="layoutOption" ref="contextMenuContainer"
        @option-clicked="menuChecked" />
      <update-animal-modal :hidden="updateAnimalVisible" @close="closeUpdateAnimal" />
      <extra-raw-info :visible="extraRawVisible" :detail="detail" @close="closeAddExtraRaw" />
      <DistributionDifference :hide="distributionVisible" @close="closeDistribution" :formulaId="formulaId"
        :detail="distributionDetailObj" />
      <!-- 更新版本自定义弹窗（Blend） -->
      <a-modal
        :visible="updateVersionVisible"
        title="保存提醒"
        :destroyOnClose="true"
        :maskClosable="false"
        :confirmLoading="saveLoading"
        :okText="'保存并更新版本'"
        :cancelText="'取消'"
        @ok="handleUpdateVersionOk"
        @cancel="() => (updateVersionVisible = false)"
      >
        <a-alert
          type="warning"
          showIcon
          message="配方没有进行优化，或者优化后无解的情况，无法更新配方版本。"
          style="margin-bottom: 16px;"
        />
        <div style="margin-bottom: 12px;">版本号：{{ displayNextVersion }}</div>
        <a-form-model :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
          <a-form-model-item label="备注:">
            <a-textarea v-model="remark" :maxLength="150" :autoSize="{ minRows: 3, maxRows: 5 }" placeholder="输入备注信息" />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-spin>
    <SetClass @refreshDetail="getDetail" />

    <RMP-result-drawer :hidden="!RMPVisible" :fid="formulaId" @close="closeRMPModal" />
  </a-layout>
</template>

<script>
import { nhfMixins } from '../untils';
import logo from '../../../assets/images/logo_nhf.svg';
import fullScreen from '@/assets/images/icon/fullScreen.png';
import exitFullScreen from '@/assets/images/icon/exitFullScreen.png';
import NutritionEditor from './editor/NutritionEditor.vue';
import RawEditor from './editor/RawEditor.vue';
import RawEditor2 from './editor/RawEditor2.vue';
import AnalyseModal from './modal/AnalyseModal.vue';
import CompoundCreateModal from './modal/CompoundCreateModal.vue';
import RawSaveModal from "./modal/RawSaveModal.vue";
import ProductComparison from './modal/ProductComparison.vue';
import NutritionRawBox from './modal/NutritionRawBox.vue';
import CalculaBoxModal from './modal/CalculaBoxModal.vue';
import VueSimpleContextMenu from 'vue-simple-context-menu';
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css';
import CheckEBS from './modal/CheckEBS.vue';
import { getRequest } from "@/components/Common/Utils/Utils";
import UpdateAnimalModal from './modal/UpdateAnimalModal.vue';
import ExtraRawInfo from './modal/ExtraRawInfo.vue';
import DistributionDifference from './modal/DistributionDifference.vue';
import SetClass from './modal/SetClass.vue';
import RMPResultDrawer from "../components/RMPResultDrawer.vue";

export default {
  components: {
    NutritionEditor,
    NutritionRawBox,
    RawEditor,
    RawEditor2,
    CalculaBoxModal,
    ProductComparison,
    // ProductModal,
    CompoundCreateModal,
    AnalyseModal,
    CheckEBS,
    RawSaveModal,
    VueSimpleContextMenu,
    UpdateAnimalModal,
    ExtraRawInfo,
    DistributionDifference,
    SetClass,
    RMPResultDrawer
  },
  mixins: [nhfMixins],
  data() {
    return {
      supplementCount: 0,
      dayCount: 0,
      formulaId: '',
      extraRawVisible: false,
      updateAnimalVisible: false,
      ebsPushVisible: false,
      factoryName: window.localStorage.getItem("factoryName"),
      logo, fullScreen, exitFullScreen, // icon
      editorContainerHeight: 400,
      resultVisible: false,
      saveLoading: false,
      productVisible: false,
      editorVisible: false,
      lineLoading: false,
      top: 0,
      goodLoading: false,
      rawVisible: false,
      nutritenVisible: false,
      nutritenDetailVisible: false,
      needVisible: false,
      needType: null,
      productPrice: {},
      updateLoading: false,
      refreshNoticeCompound: null,
      tabSelect: "1",
      analyseVisible: false,
      blendWeight: 0,
      mixWeight: 0,
      formulaExtMix: {},
      ebsIsFalse: false,
      ebsList: [],
      distributionVisible: false,
      distributionDetailObj: {},
      titlePriceLen: 1,
      topPriceType: false,

      RMPButton: false,
      RMPVisible: false,
      rawEditorSelectedRowKeys: [],
      rawEditor2SelectedRowKeys: [],
      updateVersionVisible: false,
      remark: '',
    };
  },
  mounted() {
    this.contrastTargetAddDiff();
    this.getNutrition();
    // 获取按钮权限
    this.getBtn();
    // this.updateModal()
    this.initFormulaMixCache(1);
  },
  beforeDestroy() {
    clearInterval(this.refreshNoticeCompound);
    this.refreshNoticeCompound = null;
  },
  watch: {
    'layout.layoutType'() {
      this.init();
      this.getContainerHeight();
    },
  },
  computed: {
    displayNextVersion() {
      const current = Number(this.detail && this.detail.version ? this.detail.version : 0);
      if (isNaN(current)) {
        return this.detail && this.detail.version ? `V${this.detail.version}` : 'V1';
      }
      const next = current >= 0 ? current + 1 : 1;
      return `V${next}`;
    },
    referDistributionPriceDiff() {
      let { referDistributionLastPrice } = this.distributionDetailObj || {};
      return referDistributionLastPrice != null && this.referDistributionPriceNum != null ?
        (this.referDistributionPriceNum - referDistributionLastPrice).toFixed(this.titlePriceLen) :
        '';
    },
    referDistributionPriceDiffType() {
      return Number(this.referDistributionPriceDiff) > 0 ? "arrow-up" : "arrow-down";
    },
    distributionPriceDiff() {
      let { distributionLastPrice = 0 } = this.distributionDetailObj || {};
      return distributionLastPrice != null && this.distributionPriceNum != null ?
        ((this.distributionPriceNum || 0) - (distributionLastPrice || 0)).toFixed(this.titlePriceLen) :
        '';
    },
    distributionPriceType() {
      return Number(this.distributionPriceDiff) > 0 ? "arrow-up" : "arrow-down";
    },
    referPriceDiff() {
      let { referPrice, referLastPrice } = this.detail || {};
      return referPrice != null && referLastPrice != null ?
        (referPrice - referLastPrice).toFixed(this.titlePriceLen) :
        '';
    },
    referPriceDiffType() {
      return Number(this.referPriceDiff) > 0 ? "arrow-up" : "arrow-down";
    },
    referComputedPrice() {
      let { referPrice } = this.productPrice;
      let { referPrice: detailsPrice } = this.detail;
      return referPrice != null && detailsPrice != null
        ? (-referPrice + detailsPrice).toFixed(this.titlePriceLen)
        : "";
    },
    referComputedPriceType() {
      return Number(this.referComputedPrice) > 0 ? "arrow-up" : "arrow-down";
    },
    formulaPrice() {
      let priceObj = {
        '1': '合同价格',
        '2': '预测价格',
        '3': '库存价格',
        '4': '市场价格',
      };
      let { priceSource } = this.detail || {};
      return priceSource ? priceObj[priceSource] : '';
    },
    distributionPrice() {
      let priceObj = {
        '1': '合同价格',
        '2': '预测价格',
        '3': '库存价格',
        '4': '市场价格',
      };
      let { referPriceSource } = this.detail || {};
      return referPriceSource ? priceObj[referPriceSource] : '';
    },
    hasProductVersion() {
      let version = false;
      if (this.productPrice && this.productPrice.version > 0) version = true;
      return version;
    },
    leftStyle() {
      const { showRight, showSider } = this.layout;
      let width = showRight ? '50%' : '';
      if (!showRight && !showSider) width = '100%';
      return {
        width
      };
    },
    rightStyle() {
      const { showRight } = this.layout;
      let width = showRight ? '49.6%' : '';
      return {
        width
      };
    },
    layoutOption() {
      const other = [
        {
          name: `日粮-添加原料`,
          commit: 'topAddRawActions'
        },
        {
          name: `日粮-移除原料`,
          commit: this.rawEditorSelectedRowKeys.length > 0 ? 'topRemoveRaw': '',
          class:  this.rawEditorSelectedRowKeys.length === 0 ? 'disabledMenu' : ''
        },
        {
          name: `补充料-添加原料`,
          commit: 'bottomAddRawActions'
        },
        {
          name: `补充料-移除原料`,
          commit: this.rawEditor2SelectedRowKeys.length > 0 ? 'bottomRemoveRaw': '',
          class: this.rawEditor2SelectedRowKeys.length === 0 ? 'disabledMenu' : ''
        },
        {
          name: `额外添加原料`,
          commit: 'openAddExtraRaw'
        },
        {
          type: "divider",
        },
        {
          name: `配方优化`,
          commit: "1",
        },
        {
          name: `取整优化`,
          commit: "2",
        },
        {
          name: `取整设置`,
          commit: "toggleRoundingSet",
        },
        {
          type: "divider",
        },
        {
          name: `编辑配销差`,
          commit: 'openDistribution'
        },
        {
          type: "divider",
        },
        {
          name: `EBS校验`,
          commit: this.detail.formulaSolutionType == 1 ? "checkEBS" : '',
          class: this.detail.formulaSolutionType == 1 ? "" : 'disabledMenu'
        },
        {
          name: `生成产品`,
          commit: "saveFormula",
        },
        {
          name: `产品对比`,
          commit: this.detail.isProduct != 0 ? "togglePorductVisible" : '',
          class: this.detail.isProduct != 0 ? "" : 'disabledMenu'
        },
      ];
      return other;
    },
    computedPrice() {
      const { price, lastPrice } = this.detail;
      return lastPrice != null && price != null ? (price - lastPrice).toFixed(this.titlePriceLen) : '';
    },
    computedProductPrice() {
      let { price } = this.productPrice || {};
      let { price: detailsPrice } = this.detail;
      return price != null && detailsPrice != null ? (- price + detailsPrice).toFixed(this.titlePriceLen) : '';
    },
    mixComputedPrice() {
      const { mixPrice, mixLastPrice } = this.formulaExtMix;
      return mixLastPrice != null && mixPrice != null ? (mixPrice - mixLastPrice).toFixed(this.titlePriceLen) : '';
    },
    priceType() {
      return Number(this.computedPrice) > 0 ? 'arrow-up' : 'arrow-down';
    },
    mixPriceType() {
      return Number(this.mixComputedPrice) > 0 ? 'arrow-up' : 'arrow-down';
    },
    productPriceType() {
      return Number(this.computedProductPrice) > 0 ? 'arrow-up' : 'arrow-down';
    },
    distributionPriceNum() {
      // 净销价格 - 包材价格 - 配方优化成本 / 投入产出比
      let { netSellingPrice = 0, packageMaterialPrice = 0, inputOutputRatio = 0 } = this.distributionDetailObj || {};
      let { price = 0 } = this.detail || {};
      let num = netSellingPrice - packageMaterialPrice - (price / ((inputOutputRatio / 100) || 1));
      if (!inputOutputRatio) num = null;
      return num;
    },
    referDistributionPriceNum() {
      // 净销价格 - 包材价格 - 配方优化成本 / 投入产出比
      let { netSellingPrice = 0, packageMaterialPrice = 0, inputOutputRatio = 0 } = this.distributionDetailObj || {};
      let { referPrice = 0 } = this.detail || {};
      let num = netSellingPrice - packageMaterialPrice - (referPrice / ((inputOutputRatio / 100) || 1));
      if (!inputOutputRatio) num = null;
      return num;
    },
  },

  methods: {
    handleUpdateVersionOk() {
      this.formulaProduct();
      this.updateVersionVisible = false;
    },
    initFormulaMixCache(force = 0) {
      let params = {
        formulaId: this.formulaId,
        force
      };
      this.$http.get('/nhf-app/formulaManage/initFormulaMixCache', { params });
    },
    handleRawEditorSelectedRowKeysUpdate(keys) {
      this.rawEditorSelectedRowKeys = keys; // 更新本地状态，触发视图刷新
    },
    handleRawEditor2SelectedRowKeysUpdate(keys) {
      this.rawEditor2SelectedRowKeys = keys; // 更新本地状态，触发视图刷新
    },
    toggleRoundingSet(){
      // 调用子组件中的某个方法，例如 refreshPage
      this.$refs.rawBlockBottom.toggleRoundingSet();
    },
    getBtn() {
      let factoryId = window.localStorage.getItem('factoryId');
      if (!factoryId) return;
      this.$http.get("/iot-system/menu/buttons", { params: { controlEnd: false, factoryId } }).then(res => {
        let { success, data } = res;
        if (success) {
          this.testBtns = [];
          data && data.forEach(el => {
            if (el.path === '/nhf/blend') {
              el.children && el.children.forEach(item => {
                if (item.code === 'third-RMP-apply') this.RMPButton = true;
              });
            }
          });
        }
      });
    },
    detailWidth() {
      let e = this.$refs.editorContainer.offsetWidth;
      let f = this.$refs.formulaNameRef.offsetWidth;
      let p = this.$refs.priceRef.offsetWidth;
      if (!this.topPriceType) {
        this.topPriceType = e >= f + p * 2;
      } else {
        this.topPriceType = e >= f + p;
      }
    },
    async getDistributionDetail() {
      let res = await this.fetchGet({
        actions: this.distributionDetail,
        data: { formulaId: this.formulaId }
      });
      let { success, data } = res || {};
      if (success) {
        this.distributionDetailObj = data;
      } else {
        this.distributionDetailObj = {};
      }
    },
    openDistribution() {
      this.distributionVisible = true;
    },
    closeDistribution(type) {
      if (type) this.init();
      this.distributionVisible = false;
    },
    openAddExtraRaw() {
      this.extraRawVisible = true;
    },
    closeAddExtraRaw(type) {
      if (type) this.init();
      this.extraRawVisible = false;
    },
    copyMsg() {
      let random = '';
      // {{el.name}}【{{el.code}}】{{index === ebsList.length - 1 ? '' : '、'}}
      this.ebsList.forEach((el, index) => {
        random += `${el.name}【${el.code}】${this.ebsList.length - 1 === index ? '' : '、'}`;
      });
      random += 'EBS校验不通过';
      const input = window.document.createElement('textarea');
      window.document.body.appendChild(input);
      input.innerHTML = random;
      // input.setAttribute('value',random);
      // input.select();
      input.setAttribute('code', 1);
      input.select();
      window.document.execCommand("Copy");
      this.$message.success('复制成功');
      this.closeEbsAlert();
    },
    closeEbsAlert() {
      this.ebsList = [];
      this.ebsMessage = '';
      this.ebsType = '';
      this.ebsIsFalse = false;
    },
    checkEBS() {
      let params = {
        factoryId: window.localStorage.getItem('factoryId')
      };
      this.$http.get('/iot-factory/factorysublink/subFactoryList', { params }).then(res => {
        let { data, success } = res || {};
        if (success) {
          this.$confirm({
            title: 'EBS校验',
            content: '校验配方组分原料在工厂库存组织中是否存在？',
            cancelText: '取消',
            okText: '继续',
            onOk: async () => {
              if (data.length > 0) {
                this.ebsPushVisible = true;
              } else {
                let params = {
                  formulaId: this.formulaId,
                  ebsPushFactoryId: window.localStorage.getItem('factoryId')
                };
                this.$http.get('/nhf-app/formulaNhf/batchFormulaRawEbsCheck', { params }).then(res => {
                  let { data: msgData } = res || {};
                  this.checkEbsRes(msgData);
                });
              }
            },
          });
        }
      });
    },
    closeCheckEBS() {
      this.ebsPushVisible = false;
    },
    checkEbsRes(data) {
      if (data.length === 0) {
        this.ebsIsFalse = true;
        this.ebsMessage = '校验通过！';
        this.ebsType = 'success';
        this.$message.success('校验成功');
      } else {
        this.ebsList = data || [];
        this.ebsIsFalse = true;
        this.ebsMessage = '请注意！';
        this.ebsType = 'warning';
      }
    },
    async updateModal() {
      let formulaId = getRequest('id');
      let data = { formulaId };
      if (!formulaId) return;
      await this.fetchGet({
        actions: this.contrastTargetModelAddDiff,
        data,
      });
      this.initMounted();
    },
    contrastTargetAddDiff() {
      let params = {
        formulaId: getRequest('id')
      };
      this.$http.get('/nhf-app/formulaManage/contrastTargetAddDiff', { params }).then(res => {
        let { success } = res || {};
        if (success) this.updateModal();
      });
    },
    initMounted() {
      setTimeout(() => {
        this.getContainerHeight();
        this.setState({ calculaVisible: false, nutVisible: false });
      }, 500);
      this.init();
      this.getFactoryDetails();
    },
    changeDistributionPrice() {
      if (!this.distributionDetailObj.id) {
        return;
      }
      this.fetchPost({
        actions: this.updateOnlyFormulaDistributionDiffPrice,
        data: {
          distributionPrice: this.distributionPriceNum,
          distributionLastPrice: this.distributionDetailObj.distributionPrice,
          id: this.distributionDetailObj.id
        },
        showMessage: false,
      });
    },
    changeReferDistributionPriceNum() {
      if (!this.distributionDetailObj.id) {
        return;
      }
      this.fetchPost({
        actions: this.updateOnlyFormulaDistributionDiffReferPrice,
        data: {
          referDistributionPrice: this.referDistributionPriceNum,
          referDistributionLastPrice: this.distributionDetailObj.referDistributionPrice,
          id: this.distributionDetailObj.id
        },
        showMessage: false,
      });
    },
    async changeReferPrice(referVal) {
      await this.fetchPost({
        actions: this.updateFormulaReferPrice,
        data: {
          referPrice: referVal,
          id: getRequest('id')
        },
        showMessage: false,
      });
    },
    async countPrice({ count, index, raws, referCount }) {
      let mix = 0;
      let val = 0;
      if (index == 2) {
        this.dayCount = count;
        let { cacheData } = this.$refs.rawBlockTop;
        let hasRaw = false;
        if (!raws) {
          hasRaw = true;
        } else {
          // this.setState({getListFlag: this.getListFlag + 1})
          let rawsList = cacheData.filter(el => el.rawId === raws.rawId) || [];
          hasRaw = rawsList.length === 0;
        }

        // if(this.detail.price != count){ && (this.detail.formulaExtMix.dayPrice != count)
        if (this.detail.formulaExtMix) {
          let count2 = this.detail.formulaExtMix.dayPrice ? Number(this.detail.formulaExtMix.dayPrice) : 0;
          let price2 = !count ? 0 : Number((count || 0) * (this.blendWeight || 1) / (this.detail.totalWeight || 1)).toFixed(3);
          mix = Number(((this.detail.formulaExtMix.dayPrice || count2) + Number(price2)).toFixed(3));
          val = Math.abs(this.detail.price - Number(count));
          if (val > 0.01) {
            // this.setState({getListFlag: this.getListFlag + 1})
            this.formulaExtMix.mixPrice = mix;
            this.detail.price = Number(count) || 0;
          }
        }
        let referMix = Math.abs((this.detail.referPrice || 0) - (referCount || 0)) > 0.01;
        if (hasRaw && (val > 0.01 || referMix)) {
          this.detail.referPrice = Number(referCount) || 0;
          // let newData = JSON.parse(JSON.stringify(this.detail))
          if (this.referPriceSourceChange || referMix) {
            await this.changeReferDistributionPriceNum();
            this.setState({ referPriceSourceChange: false });
          }
          if (this.priceSourceChange || val > 0.01) {
            await this.changeDistributionPrice();
            this.setState({ priceSourceChange: false });
          }
          // console.log('newData-price',newData.price)
          // console.log('detail-price',this.detail.price)
          await this.updatePrice(this.detail);
        }
        // }
      } else if (index === 1) {
        this.supplementCount = count;
        let { cacheData } = this.$refs.rawBlockBottom;
        let hasRaw = false;
        if (!raws) {
          hasRaw = true;
        } else {
          // this.setState({getListFlag: this.getListFlag + 1})
          let rawsList = cacheData.filter(el => el.rawId === raws.rawId) || [];
          hasRaw = rawsList.length === 0;
        }
        if (this.detail.formulaExtMix) {
          let price2 = !this.detail.price ? 0 : Number((this.detail.price || 0) * (this.blendWeight || 1) / (this.detail.totalWeight || 1)).toFixed(3);
          mix = Number((count + Number(price2)).toFixed(3));
          val = Math.abs(this.formulaExtMix.mixPrice - mix);
          if (val > 0.01) {
            // this.setState({getListFlag: this.getListFlag + 1})
            this.formulaExtMix.mixPrice = mix;
            this.detail.formulaExtMix.dayPrice = count;
          }
          if (hasRaw && (val > 0.01)) {
            // this.setState({getListFlag: this.getListFlag + 1})
            this.updatePrice(this.detail);
          }
        }
      }

    },

    async updatePrice(data) {
      await this.fetchPost({
        actions: this.updateFormulaMixPrice,
        loading: "updateLoading",
        showMessage: false,
        data,
      });

      if (data.formulaSolutionType) {
        await this.getDetail();
        await this.getDistributionDetail();
      }
    },
    async getNutrition() {
      const res = await this.fetchGet({
        actions: this.animalNutritionUserPage,
        showMessage: false,
        data: {
          size: 1000, current: 1
        },
      });
      let { success, data } = res || {};
      if (success) {
        this.setState({ nutritionList: data.records || [] });
      }
    },
    getFactoryDetails() {
      let id = window.localStorage.getItem('factoryId');
      if (!id) {
        this.$get('/iot-factory/factory/detail', { id }).then(res => {
          let { success, data } = res || {};
          if (success) {
            let { overseasFlag } = data || {};
            this.overseasFlag = overseasFlag;
            if (overseasFlag != window.localStorage.getItem('overseasFlag')) {
              window.localStorage.setItem('overseasFlag', overseasFlag);
            }

            // 存一个工厂的详细信息
            window.localStorage.setItem('factoryDetail', JSON.stringify(data));
          }
        });
      }
    },
    calculation(list, otherList) {
      this.$refs['calculaBoxModal'].setResult(list, otherList);
    },
    changeTab() {
      this.$refs.nutritionRawBox && this.$refs.nutritionRawBox.resetList();
    },
    async init() {
      const { id } = this.$route.query;
      this.formulaId = id;

      await this.refreshPage();
      window.onresize = () => this.getContainerHeight();
      this.dragRowDiv();
      setTimeout(() => {
        this.dragControllerDiv();
        this.getDistributionDetail();
      }, 0);
    },
    removeRaw() {
      this.$refs['rawBlockTop'].removeRaw();
      this.$refs['rawBlockBottom'].removeRaw();
    },
    addRawActions() {
      this.$refs['rawBlockTop'].toggleRawVisible();
      this.$refs['rawBlockBottom'].toggleRawVisible();
    },
    topRemoveRaw() {
      this.$refs['rawBlockTop'].removeRaw();
    },
    topAddRawActions() {
      this.$refs['rawBlockTop'].toggleRawVisible();
    },
    bottomRemoveRaw() {
      this.$refs['rawBlockBottom'].removeRaw();
    },
    bottomAddRawActions() {
      this.$refs['rawBlockBottom'].toggleRawVisible();
    },
    goBack() {
      this.$router.push('/nhf/blend?name=混合日粮');
    },
    handleLayout(e) {
      this.toggleLayout(e.key);
    },
    handleMenu(event) {
      this.$refs.contextMenuContainer.showMenu(event);
    },
    menuChecked({ option }) {
      const { commit } = option;
      this.rightClick({ key: commit });
      // this.toggleLayout(commit)
    },

    rightClick(e) {
      let { key } = e || {};
      if (key === '1' || key === '2') {
        this.changeLinear({ key });
      } else if (key === 'saveFormula') {
        this.saveFormula({ key: 2 });
      } else {
        this[key]();
      }
    },

    toggleHasAnalyse() {
      this.rawRows.length > 1 ? this.$message.warn('只能选中一个原料') : this.toggleAnalyse();
    },

    // 梯度分析
    toggleAnalyse() {
      this.analyseVisible = !this.analyseVisible;
    },

    getContainerHeight() {
      const boxHeight = this.$refs['editorContainer'] ? this.$refs['editorContainer'].offsetHeight : 500;
      const height = boxHeight - 160;
      // const box = this.$refs.editorContainer
      this.editorContainerHeight = height;
      let num = 70;
      let bottomNum = 75;
      let top = boxHeight / 3;
      let bottom = boxHeight - top - num;
      if (this.$refs['leftBoxTopHeight']) this.$refs['leftBoxTopHeight'].style.height = top + 'px';
      if (this.$refs['leftBoxBottomHeight']) this.$refs['leftBoxBottomHeight'].style.height = bottom + 'px';
      this.setState({ height, leftBoxTopHeight: top - 80, leftBoxBottomHeight: bottom - bottomNum });
    },

    // 配方页通知已读
    async refreshUpdate(callback, showMsg, record) {
      // const {formulaId} = this
      this.$refs['rawBlockTop'].getList({}, record);
      this.$refs['rawBlockBottom'].getList({}, record);
      // const res = await this.fetchPost({
      //   actions:this.updateFormulaNoticeStatus,
      //   data:{ formulaId },
      //   showMessage:false,
      // })
      // callback && callback()
      // return res
    },
    totalRefreshUpdate() {
      this.getRes();
      // this.refreshUpdate()
    },
    getRes(record) {
      if (record && record.feild === 'price') this.getPrice();
      // // 配方最优解
      let updateData = {
        "formulaSolutionType": "0",
        "id": getRequest('id')
      };
      this.fetchPost({
        actions: this.updateFormulaFormulaSolutionType,
        data: updateData,
        showMessage: false
      });
      this.detail.formulaSolutionType = '0';
      if (record && record.feild === 'price') {
        this.$refs['rawBlockTop'].getList({}, record);
        this.$refs['rawBlockBottom'].getList({}, record);
      }
    },
    async refreshPage() {
      clearInterval(this.refreshNoticeCompound);
      this.refreshNoticeCompound = null;
      await this.getPrice();
      await this.getDetail();
      await this.getDistributionDetail();
      this.$refs['rawBlockTop'] && this.$refs['rawBlockTop'].getList();
      this.$refs['rawBlockBottom'] && this.$refs['rawBlockBottom'].getList();
      this.$refs['nutritionBlock']
        && this.$refs['nutritionBlock'].$refs['totalList'] && this.$refs['nutritionBlock'].$refs['totalList'].getList()
        && this.$refs['nutritionBlock'].$refs['blendList'] && this.$refs['nutritionBlock'].$refs['blendList'].getList();
    },
    refreshList() {
      this.$refs['nutritionBlock'] && this.$refs['nutritionBlock'].init();
    },

    async changeLinear({ key: optimizationType }) {
      if (this.$refs['rawBlockTop'].cacheData.length == 0) {
        this.$message.warning('请添加日粮后优化');
        return;
      }
      if (this.$refs['rawBlockBottom'].cacheData.length == 0) {
        this.$message.warning('请添加补充料后优化');
        return;
      }
      let countRationMin = 0;
      let countSupplementaryMin = 0;
      const topRef = this.$refs["rawBlockTop"] || {};
      const bottomRef = this.$refs["rawBlockBottom"] || {};
      // 优先读取子组件 list.records（切换口径时会对其做换算），无则回退 cacheData
      let rationList = (topRef.list && topRef.list.records && topRef.list.records.length) ? topRef.list.records : topRef.cacheData;
      let supplementaryList = (bottomRef.list && bottomRef.list.records && bottomRef.list.records.length) ? bottomRef.list.records : bottomRef.cacheData;
      let { selfProvidedProportion = 0, constraintOptions = 'day' } = this.formulaExtMix || {};
      // 若子组件已切换但父级未刷新 detail，则以子组件当前口径为准
      constraintOptions = bottomRef.constraintOptions || topRef.constraintOptions || constraintOptions || 'day';
      console.log('[BlendEditorCol.changeLinear] use constraintOptions:', constraintOptions);
      rationList && rationList.forEach(el => {
        if (el.isExtraProRaw !== '1' && el.isRawDelete !== '1') {
          countRationMin += Number(el.minValue || 0);
        }
      });
      supplementaryList && supplementaryList.forEach(el => {
        if (el.isExtraProRaw !== '1' && el.isRawDelete !== '1') {
          countSupplementaryMin += Number(el.minValue || 0);
        }
      });

      let nutritionBlock = this.$refs.nutritionBlock;
      // let {activeKey} = nutritionBlock || {}
      let totalList = nutritionBlock.$refs.totalList || {};
      let blendList = nutritionBlock.$refs.blendList || {};
      let list3 = totalList.cacheData || [];
      let list4 = blendList.cacheData || [];
      let warnFlag = false;
      let gt = '>';
      let contentStr = '';
      let contentStr2 = '';
      let contentStr3 = '';
      let contentStr4 = '';
      let str = rationList && rationList.map(el => {
        if ((el.minValue || el.minValue === 0) && (el.maxValue || el.maxValue === 0) && (Number(el.minValue) > Number(el.maxValue))) {
          warnFlag = true;
          contentStr += `日粮:【${el.rawName}】的最小值 ${gt} 最大值；\r\n`;
          return <p>日粮:【{el.rawName}】的最小值 {gt} 最大值；</p>;
        }
      });
      let str2 = supplementaryList && supplementaryList.map(el => {
        if ((el.minValue || el.minValue === 0) && (el.maxValue || el.maxValue === 0) && (Number(el.minValue) > Number(el.maxValue))) {
          warnFlag = true;
          contentStr2 += `补充料:【${el.rawName}】的最小值 ${gt} 最大值；\r\n`;
          return <p>补充料:【{el.rawName}】的最小值 {gt} 最大值；</p>;
        }
      });
      let str3 = list3 && list3.map(el => {
        if ((el.minValue || el.minValue === 0) && (el.maxValue || el.maxValue === 0) && (Number(el.minValue) > Number(el.maxValue))) {
          warnFlag = true;
          contentStr3 += `合计:【${el.nutritionName}】的最小值 ${gt} 最大值；\r\n`;
          return <p>合计:【{el.nutritionName}】的最小值 {gt} 最大值；</p>;
        }
      });
      let str4 = list4 && list4.map(el => {
        if ((el.minValue || el.minValue === 0) && (el.maxValue || el.maxValue === 0) && (Number(el.minValue) > Number(el.maxValue))) {
          warnFlag = true;
          contentStr4 += `合计-补充料:【${el.nutritionName}】的最小值 ${gt} 最大值；\r\n`;
          return <p>合计-补充料:【{el.nutritionName}】的最小值 {gt} 最大值；</p>;
        }
      });
      // if(activeKey == 1){
      //   str4 = null
      //   contentStr4 = ''
      // }else{
      //   str3 = null
      //   contentStr3 = ''
      // }
      if (warnFlag) {
        this.$confirm({
          icon: () => <a-icon type="exclamation-circle" theme="twoTone" two-tone-color="#ffa600" />,
          title: '请注意',
          content: <div>{str}{str2}{str3}{str4}</div>,
          cancelText: '返回修改',
          okText: '复制信息',
          width: 500,
          // duration: 0,
          onOk: () => {
            let random = contentStr + contentStr2 + contentStr3 + contentStr4;
            const input = window.document.createElement('textarea');
            window.document.body.appendChild(input);
            input.innerHTML = random;
            // input.setAttribute('value',random);
            // input.select();
            input.setAttribute('code', 1);
            input.select();
            window.document.execCommand("Copy");

            var list = document.getElementsByTagName('textarea');
            var inputList = Array.prototype.slice.call(list);
            inputList.forEach((item) => {
              if (item.getAttribute('code')) document.body.removeChild(item);
            });
            this.$message.success('复制成功');
          },
          class: 'test',
        });
        return;
      }
      countRationMin = Number(countRationMin.toFixed(3));
      selfProvidedProportion = Number(Number(selfProvidedProportion).toFixed(3));
      if (countRationMin > selfProvidedProportion) {
        this.$warning({
          title: '配方无解',
          content: <div>
            <p>日粮原料最小值总和为：<span style="color: #ff4d4f;">{countRationMin.toFixed(3)}</span> ，请调整原料约束!</p>
          </div>,
        });
        return;
      }
      let s = Number((100 - selfProvidedProportion).toFixed(3));
      countSupplementaryMin = Number(countSupplementaryMin.toFixed(3));
      const supplementaryTarget = constraintOptions === 'supplementary' ? 100 : s;
      console.log('[BlendEditorCol.changeLinear] countSupplementaryMin:', countSupplementaryMin, 'target:', supplementaryTarget, 'constraintOptions:', constraintOptions);
      if (countSupplementaryMin > supplementaryTarget) {
        this.$warning({
          title: '配方无解',
          content: <div>
            <p>补充料原料最小值总和为：<span style="color: #ff4d4f;">{countSupplementaryMin.toFixed(3)}</span> ，请调整原料约束!</p>
          </div>,
        });
        return;
      }
      const data = {
        formulaId: this.formulaId,
        optimizationType
      };
      this.$track.sendTrack('clickEvent');
      const res = await this.fetchGet({
        actions: this.mixLinearOptimizationByOptimization,
        data,
        showError: false,
        loading: 'lineLoading'
      });
      if (res && res.success) {
        if (res.data.formulaSolutionType == '3') {
          this.$confirm({
            title: "优化成功，但存在以下有最小值却没有使用的原料",
            content: <span class='colorRed'>{res.data.msg}</span>,
            okText: '知道了',
            icon: 'info-circle',
            cancelButtonProps: {
              style: { display: 'none' }
            },
            onOk: () => this.refreshPage()
          });
        } else {
          this.refreshPage();
          this.refreshList();
          this.$message.success(res.data ? res.data.msg : '');
        }
      } else {
        this.$warning({
          title: '优化失败',
          content: res.msg,
          // content: '配方无解，请检查配方原料或营养需要量约束条件！',
          cancelText: '确定'
        });
      }
      this.setState({ calculaVisible: false, nutVisible: false, ishandle: true, });
    },

    viewReport({ key }) {
      // let routeUrl = this.$router.resolve({
      //   path:`/nhf-mix-report?id=${this.formulaId}&formulaReportType=${formulaReportType}`
      // })
      // window.open(routeUrl.href, '_blank')
      let url = [
        '/nhf-app/formulahis/exportMixFormulaExcelReport',
        '/nhf-app/formulahis/exportMixFormulaProExcelReport',
        "/nhf-app/formulahis/exportMixFormulaProductExcelReport",
        "/nhf-app/formulahis/exportProduceMixFormulaProExcelReport",
        '/nhf-app/formulahis/exportMixFormulaCompleteExcelReport',
      ];

      let aliasFlag = window.localStorage.getItem('overseasFlag') == 1 ? 1 : 0;
      this.$fileDownload(url[key - 1], { formulaId: this.formulaId, aliasFlag }).catch(e => {
        e.message && this.$message.error(e.message);
      });
    },

    prcieChange(val) {
      if (val) this.detail.price = val;
    },

    async update(data) {
      this.toggleEditorVisible();
      await this.fetchPost({
        actions: this.mixUpdate,
        loading: 'updateLoading',
        data
      });
      this.init();
      if (this.$refs.nutritionBlock) this.$refs.nutritionBlock.init();
    },

    toggleEditorVisible() {
      this.editorVisible = !this.editorVisible;
    },

    togglePorductVisible() {
      this.productVisible = !this.productVisible;
      this.setState({ calculaVisible: false, nutVisible: false });
    },

    tabChange(val) {
      this.tabSelect = val;
      this.setState({ rawRows: [], nutRows: [] });
    },

    async linearGood() {
      await this.fetchGet({
        actions: this.linearOptimization,
        loading: 'goodLoading',
        data: {
          formulaId: this.formulaId
        }
      });
      this.refreshPage();
    },

    toggleNeedVisible() {
      if (this.selectNutData.length > 1) {
        this.$message.info(`多个营养指标养分不能同时查看`);
      } else {
        this.needVisible = !this.needVisible;
      }
    },

    toggleNutritenVisible() {
      if (this.rawSelect.length > 1) {
        this.$message.info(`多个原料不能同时查看`);
      } else {
        this.nutritenVisible = !this.nutritenVisible;
      }
    },

    toggleRawPanel() {
      this.rawVisible = !this.rawVisible;
    },

    toggleHidden(name) {
      if (this[name].length > 1) {
        this.$message.info(`多个${this.name == 'raw' ? '原料' : '营养指标养分'}不能同时查看`);
        return;
      }
      const visible = name == 'rawRows' ? 'raw' : 'nut';
      this.toggleVisible(visible);
    },
    async getPrice() {
      const productPrice = await this.fetchPost({
        actions: this.getProductPrice,
        showMessage: false,
        data: {
          formulaId: this.formulaId
        }
      });
      this.productPrice = productPrice;

    },
    async getDetail() {
      const res = await this.fetchGet({
        actions: this.mixDetail,
        // name:'detail',
        data: {
          formulaId: this.formulaId,
        }
      });
      if (res && res.data) {
        let { formulaExtMix, totalWeight = 0 } = res.data;
        let { selfProvidedProportion = 0 } = formulaExtMix || {};
        this.setState({ detail: res.data });
        this.formulaExtMix = formulaExtMix;
        // 日粮重量
        this.mixWeight = totalWeight * selfProvidedProportion / 100;
        // 补充料重量
        this.blendWeight = totalWeight * (100 - selfProvidedProportion) / 100;
        if (this.deleteIds.includes(res.data.animalTypeCode)) {
          this.updateAnimalVisible = true;
        }
        if (!res.data.typeClassify) {
          this.setState({ setClassVisible: true });
        }
      }
      // this.detailWidth()
    },
    dragRowDiv() {
      const resize = document.getElementsByClassName('resizeBottom');
      const top = this.$refs.leftBoxTopHeight;
      const bottom = this.$refs.leftBoxBottomHeight;
      const box = this.$refs.editorContainer;
      // const left = document.getElementsByClassName('tableleft')
      // const mid = document.getElementsByClassName('tableBottom')
      // const box = document.getElementsByClassName('nhf-layout')
      for (let i = 0; i < resize.length; i++) {
        resize[i].onmousedown = () => {
          resize[i].style.background = '#e8e8e8';
          let min = 200;
          document.onmousemove = e => {
            var endY = e.clientY;
            let tHeight = (endY - 105);
            let bHeight = (box.offsetHeight - tHeight);
            if (tHeight < min) {
              tHeight = min;
              bHeight = box.offsetHeight - tHeight;
            }
            if (bHeight < min + 100) {
              bHeight = min + 100;
              tHeight = box.offsetHeight - bHeight;
            }
            let hNum = 70;
            if (tHeight >= min && bHeight >= min) {
              top.style.height = tHeight + 'px';
              bottom.style.height = bHeight - hNum + 'px';
            }
            let leftBottomNum = 145;
            let leftTopNum = 80;
            this.setState({ leftBoxTopHeight: tHeight - leftTopNum, leftBoxBottomHeight: bHeight - leftBottomNum });
          };
          document.onmouseup = () => {
            resize[i].style.background = '#fff';
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture();
          };
          resize[i].setCapture && resize[i].setCapture();
          return false;
        };
      }
    },
    dragControllerDiv() {
      const resize = document.getElementsByClassName('resize');
      const left = document.getElementsByClassName('tableleft');
      const mid = document.getElementsByClassName('tableright');
      const box = document.getElementsByClassName('nhf-layout');
      left[0] && this.setState({ leftWidth: left[0].clientWidth - 24, rightWidth: mid[0].clientWidth - 24 });
      for (let i = 0; i < resize.length; i++) {
        resize[i].onmousedown = e => {
          resize[i].style.background = '#e8e8e8';
          let startX = e.clientX;
          resize[i].left = resize[i].offsetLeft;
          document.onmousemove = e => {
            var endX = e.clientX;
            var moveLenght = resize[i].left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
            var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度
            if (moveLenght < 400) moveLenght = 400; // 左边区域的最小宽度为32px
            if (moveLenght > maxT - 400) moveLenght = maxT - 400; //右边区域最小宽度为150px
            resize[i].style.left = moveLenght; // 设置左侧区域的宽度
            for (let j = 0; j < left.length; j++) {
              if (moveLenght >= 500 && box[i].clientWidth - moveLenght - 5 >= 500) {
                // mid[j].style.width = (box[i].clientWidth - moveLenght - 5 )  + 'px'
                // left[j].style.width = moveLenght + 'px'
                let leftWidth = parseInt(moveLenght / box[i].clientWidth * 100);
                let rightWidth = parseInt((box[i].clientWidth - moveLenght - 5) / box[i].clientWidth * 100);
                left[j].style.width = leftWidth + '%';
                mid[j].style.width = rightWidth + '%';
              }
            }
            if (moveLenght >= 500 && box[i].clientWidth - moveLenght - 5 >= 500) {
              this.setState({ rightWidth: box[i].clientWidth - moveLenght - 29, leftWidth: moveLenght - 24 });
            }
          };
          document.onmouseup = () => {
            resize[i].style.background = '#fff';
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture();
          };
          resize[i].setCapture && resize[i].setCapture();
          return false;
        };
      }
    },

    checkLinerTop() {
      return this.$refs['rawBlockTop'].list.records.some(i => i.percentage === '' || i.percentage === null);
    },
    checkLinerBottom() {
      return this.$refs['rawBlockBottom'].list.records.some(i => i.percentage === '' || i.percentage === null);
    },

    saveCompound() {
      if (this.checkLinerTop() || this.checkLinerBottom()) {
        this.$message.warning('配方还未优化,无法更新配方版本');
        return;
      }
      this.updateVersionVisible = true;
    },

    async saveProductCompound() {
      if (!this.checkRawTop() || !this.checkRawBottom()) {
        this.$warning({
          title: '产品生成失败',
          content: "配方中没有原料，无法生成产品！"
        });
        // this.$message.warning('配方中没有原料，无法生成产品！')
        return;
      }
      if (this.detail.formulaSolutionType !== '1') {
        this.$warning({
          title: '产品生成失败',
          content: "配方还未优化，无法生成产品！"
        });
        // this.$message.warning('配方还未优化,无法生成产品！')
        return;
      }
      await this.saveProduce();
    },
    checkRawTop() {
      return this.$refs['rawBlockTop'].list.records && this.$refs['rawBlockTop'].list.records.length > 0;
    },
    checkRawBottom() {
      return this.$refs['rawBlockBottom'].list.records && this.$refs['rawBlockBottom'].list.records.length > 0;
    },

    async saveFormulaProVersion() {
      await this.fetchPost({
        actions: this.saveProVersion,
        loading: 'saveLoading',
        data: {
          formulaId: this.formulaId
        }
      });
      // this.$message.success('配方已保存！')
      this.refreshPage();
    },

    async formulaProduct() {
      await this.fetchPost({
        actions: this.saveMixFormulaProduct,
        loading: 'saveLoading',
        data: {
          formulaId: this.formulaId,
          remark: this.remark,
        }
      });
    },

    async saveProduce() {
      const hide = this.$message.loading('产品生成中，请稍后...', 0);
      await this.fetchPost({
        actions: this.saveMixFormulaInfoPro,
        loading: 'saveLoading',
        data: { formulaId: this.formulaId },
        modalMsg: '产品生成失败'
      });
      this.refreshPage();
      this.refreshList();
      setTimeout(hide, 0);
    },

    saveRawFormula() {
      if (this.$refs["rawBlockTop"].list.records.length == 0 || this.$refs['rawBlockBottom'].list.records.length == 0) {
        this.$message.warning("请添加原料");
        return;
      }
      if (this.detail.formulaSolutionType == 0) {
        this.$message.warning("配方还未优化,无法保存为原料");
        return;
      }
      this.toggleVisible("saveRaw");
    },
    async saveFormula({ key }) {
      this.closeEbsAlert();
      const actions = [this.saveFormulaProVersion, this.saveCompound, this.saveProductCompound, this.saveRawFormula];
      if (key == 2) {
        if (this.detail.formulaSolutionType === '0') {
          this.$message.warning('请先进行配方优化');
          return;
        }
      }
      // 更新版本和保存为原料不需要校验配方中是否包含失效原料
      if (key == 0 ||key == 1 || key == 3) {
        await actions[key]();
        this.setState({ calculaVisible: false, nutVisible: false });
        return;
      }
      let checkProduct = await this.fetchGet({
        actions: this.checkCreatePro,
        loading: "saveLoading",
        data: { formulaId: this.formulaId },
      });
      let { success, msg, code } = checkProduct || {};
      if (!success) {
        if (code === 500) {
          this.$confirm({
            title: '提示信息',
            content: '配方原料中包含失效原料:' + msg + '，是否仍要生成产品？',
            cancelText: '取消',
            okText: '确定',
            onOk: () => {
              console.log("now  continue save product");
              actions[key]();
              this.setState({ calculaVisible: false, nutVisible: false });
            },
            onCancel: () => {
            }
          });
        } else {
          this.$message.warning(msg);
        }

      } else {
        await actions[key]();
        this.setState({ calculaVisible: false, nutVisible: false });
      }
    },

    closeUpdateAnimal(type) {
      if (type) {
        this.init();
      }
      this.updateAnimalVisible = false;
    },

    openRMPResult() {
      this.RMPVisible = true;
    },
    closeRMPModal() {
      this.RMPVisible = false;
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep .ant-tabs-bar {
  margin: 0 10px;
}

::v-deep .disabledMenu {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed !important;
}

::v-deep .disabledMenu:hover {
  background-color: #f5f5f5 !important;
  color: rgba(0, 0, 0, 0.25) !important;
}

.ant-tooltip-inner {
  font-size: 12px;
}

::v-deep .vue-simple-context-menu {
  box-shadow: 0 4px 12px rgba($color: #000000, $alpha: 0.3);
  background: #fff;

  &--active {
    background: #fff;
    color: #444;
  }

  &__item {
    width: 180px;
    font-size: 13px;

    span {
      width: 180px;
      display: flex;
      justify-content: space-between;
      padding: 3px 0;

      b {
        font-weight: normal;
      }
    }

    i {
      width: 13px;
      height: 7px;
      border: 2px solid #1890ff;
      border-top: none;
      border-right: none;
      transform: rotate(-45deg) scale(0.9) translateY(4px);
    }

    &:hover {
      background-color: lighten(#1890ff, 44%);
      color: #1890ff;
    }
  }

  &__divider {
    height: 1px;
    background-color: #e8e8e8;
  }
}

.tableleft,
.tableright,
.resize {
  float: left;
}

.nhf-editor {
  overflow: hidden;

  &-container {
    max-width: 1400px;
    margin: 0 auto;
  }
}

.nhf-app {
  overflow: hidden;
  height: 100vh;
  max-height: 100vh;
  min-width: 1050px;

  h1,
  h2,
  h3,
  h4 {
    margin: 0;
    padding: 0;
  }
}

.nhf-layout h2 {
  font-size: 14px;
  padding: 15px !important;
}

.nhf-header {
  padding: 10px 20px 0;
}

.nhf-title {
  font-size: 14px;
  font-weight: 800;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.nhf-logo {
  // width:80px;
  height: 23px;
  margin-right: 8px;
}

.nhf-title span {
  color: #1890ff;
  padding: 0 4px;
  border-left: 4px solid #1890ff;
  line-height: 12px;
}

.nhf-header-main {
  padding: 8px 15px 4px;
  border-bottom: 1px solid #e8e8e8;
}

.nhf-header-main h3 {
  font-size: 18px;
  color: #444;
}

.ant-table-thead>tr>th,
.ant-table-tbody>tr>td {
  position: relative !important;
}

.ant-table-row-cell-break-word {
  position: relative !important;
}

.nhf-container {
  border-radius: 5px;
  background: #fff;
  min-width: 800px;
  margin: 10px 20px 15px;
  height: calc(100vh - 70px);
  border-radius: 5px;
  background: #fff;
}

.editor-container {
  flex: 1;
}

.col {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 0 10px;
  font-size: 12px;

  h2 {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 18px;
    font-weight: 900;
    color: #444;

    span {
      &.red {
        color: red;
      }

      &.green {
        color: green;
      }

      b {
        color: #444;
        margin: 0 4px;
      }
    }
  }
}

.ant-layout-content {
  min-height: 100vh;
}

.appBox {
  height: inherit !important;
}

.resizeBottom {
  cursor: row-resize;
  height: 4px;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &:hover {
    color: #444444;
  }

  &:after {
    top: -2px;
    bottom: -2px;
    border: 1px solid #888;
    border-left: none;
    border-right: none;
    width: 22px;
    content: "";
    position: absolute;
    left: 50%;
  }

  &:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    background-color: #e8e8e8;
    height: 1px;
  }
}

.resize {
  cursor: col-resize;
  width: 4px;
  height: calc(100vh - 132px);
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &:hover {
    color: #444444;
  }

  &:after {
    left: -2px;
    right: -2px;
    border: 1px solid #888;
    border-top: none;
    border-bottom: none;
    height: 22px;
    content: "";
    margin-top: -11px;
    position: absolute;
    top: 50%;
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    background-color: #e8e8e8;
    width: 1px;
  }
}
</style>
